module.exports = __webpack_public_path__ + "static/media/wedding.1f3cd29e.png";